"use client";

import { useEffect, useState } from "react";
import { IconMoon, IconSun } from "./icons";
import { KEYS } from "./keys";
import { t, type Lang } from "@/lib/i18n/index";
type Theme = "light" | "dark";

/**
 * Day and night on html[data-theme]. Both icons are in the markup and the
 * stylesheet shows the one that applies, so the server renders the same
 * button whatever the visitor chose; only the label has to catch up once
 * mounted.
 */
export function ThemeToggle({ lang }: { lang: Lang }) {
  const s = t(lang);
  const [theme, setTheme] = useState<Theme>("light");

  useEffect(() => {
    setTheme(document.documentElement.getAttribute("data-theme") === "dark" ? "dark" : "light");
  }, []);

  function toggle() {
    const next: Theme = theme === "dark" ? "light" : "dark";
    setTheme(next);
    document.documentElement.setAttribute("data-theme", next);
    try {
      localStorage.setItem(KEYS.theme, next);
    } catch {
      // Still switches for this visit.
    }
  }

  const label = theme === "dark" ? s["theme.toLight"] : s["theme.toDark"];
  return (
    <button type="button" className="icon-btn" data-track="shell.theme" onClick={toggle} aria-label={label} title={label}>
      <IconSun />
      <IconMoon />
    </button>
  );
}
